<template>
  <div class="p-5 bg-vice-light-grey rounded-br-lg rounded-tr-lg">
    <ul role="list" class="divide-y divide-medium-grey text-vice-dark-teal">
      <li class="flex items-center mx-auto py-10">
        <img
          class="block ml-4 mr-8"
          width="58"
          height="30"
          src="/image/icons/smart-glass.svg"
          alt="SmartGlass"
        />
        <p class="text-base font-normal leading-6 w-80">
          Please wait while the clinician is setting up the
          <span class="font-bold">consultation with the medical devices.</span>
          This can take a few minutes.
        </p>
      </li>
      <li class="flex items-center mx-auto py-10">
        <img
          class="block ml-5 mr-11"
          width="45"
          height="68"
          src="/image/icons/person-intro.svg"
          alt="SmartGlass"
        />
        <p class="text-base font-normal leading-6 w-80">
          When the consultation starts, you will be asked to
          <span class="font-bold">introduce yourselves to the patient.</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
